export const MOBILE_HEADER_OFFSET = 104;
export const MODAL_HEADER_OFFSET = 72;
